import debounce from 'lodash.debounce';
import React from 'react';
import { SearchInput } from '../../../components';
import PropTypes from 'prop-types'

const FormKeyword = ({ defaultValue, onSubmit }) => {
  const [keyword, setKeyword] = React.useState('')

  const handleSearchInput = debounce((e) => {
    setKeyword(e.target.value)
  }, 250)

  const handleSearchSubmit = () => {
    console.log(keyword)
    onSubmit(keyword)
  }

  return <SearchInput
    className="text-sm"
    defaultValue={defaultValue}
    onChange={(e) => {e.persist(); handleSearchInput(e)}}
    onSearchSubmit={() => handleSearchSubmit()}
  />
}

FormKeyword.propTypes = {
  defaultValue: PropTypes.string,
  onSubmit: PropTypes.func
}

FormKeyword.defaultProps = {
  defaultValue: '',
  onSubmit: () => {},
}

export default FormKeyword
